export function addSticky() {
  const stickyElm = document.getElementById("sticky-select-bar");
  if (!("IntersectionObserver" in window)) {
    // Fallback for browsers that do not support IntersectionObserver
    stickyElm.classList.add("isSticky");
    return;
  }
  const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle("isSticky", e.intersectionRatio < 1),
    { threshold: [1] }
  );
  observer.observe(stickyElm);
}
